import { render, staticRenderFns } from "./ReportDeskWorklist.vue?vue&type=template&id=0cebce2a&scoped=true"
import script from "./ReportDeskWorklist.vue?vue&type=script&lang=js"
export * from "./ReportDeskWorklist.vue?vue&type=script&lang=js"
import style0 from "./ReportDeskWorklist.vue?vue&type=style&index=0&id=0cebce2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cebce2a",
  null
  
)

export default component.exports